import { OrganisationSponsorship, ScholarshipSponsorship } from '../../types';
import { formatCurrency } from '../formatting';

export function dependantChildrenLabel(number: number): string {
  return number === 1 ? 'Dependant Child' : `Dependant Children x${number}`;
}

// courses are any entries that aren't living cost ids
export function coversCourses(fundingEligibility: Array<string>): boolean {
  return (
    fundingEligibility?.length > 0 &&
    fundingEligibility?.some(cover => !['studentLivingCost', 'spouseLivingCost', 'childrenLivingCost'].includes(cover))
  );
}

export function coversLiving(fundingEligibility: Array<string>): boolean {
  return (
    fundingEligibility.length > 0 &&
    fundingEligibility.some(cover => ['studentLivingCost', 'spouseLivingCost', 'childrenLivingCost'].includes(cover))
  );
}

function courseFundLabel(sponsor: OrganisationSponsorship | ScholarshipSponsorship) {
  switch (sponsor.courseFundType) {
    case 'Full':
      return 'Full';
    case 'Percentage':
      return `${sponsor.courseFundPercentage ?? 0}%`;
    case 'Amount':
      return `£${formatCurrency(sponsor.courseFundAmount ?? 0)}`;
    default:
      return '';
  }
}

function livingFundLabel(sponsor: OrganisationSponsorship | ScholarshipSponsorship) {
  switch (sponsor.livingFundType) {
    case 'Full':
      return 'Full';
    case 'Percentage':
      return `${sponsor.livingFundPercentage ?? 0}%`;
    case 'Amount':
      switch (sponsor.livingFundAmountType) {
        case 'Monthly':
          return `£${formatCurrency(sponsor.livingFundAmount ?? 0)}/mon.`;
        case 'Total':
          return `£${formatCurrency(sponsor.livingFundAmount ?? 0)}`;
        default:
          return '';
      }
    default:
      return '';
  }
}

function courseAndLivingFundLabel(sponsor: OrganisationSponsorship | ScholarshipSponsorship) {
  switch (sponsor.courseAndLivingFundType) {
    case 'Full':
      return 'Full';
    case 'Percentage':
      return `${sponsor.courseAndLivingFundPercentage ?? 0}%`;
    case 'Amount':
      return `£${formatCurrency(sponsor.courseAndLivingFundAmount ?? 0)}`;
    default:
      return '';
  }
}

export function sponsorFundLabel(sponsor: OrganisationSponsorship | ScholarshipSponsorship): string {
  if (coversCourses(sponsor.sponsorshipCovers) && coversLiving(sponsor.sponsorshipCovers)) {
    if (sponsor.courseAndLivingFundSeparate === true) {
      return `${courseFundLabel(sponsor)}, ${livingFundLabel(sponsor)}`;
    } else if (sponsor.courseAndLivingFundSeparate === false) {
      return courseAndLivingFundLabel(sponsor);
    }
    return '';
  } else if (coversCourses(sponsor.sponsorshipCovers)) {
    return courseFundLabel(sponsor);
  } else if (coversLiving(sponsor.sponsorshipCovers)) {
    return livingFundLabel(sponsor);
  }
  return '';
}
